import { useState, useEffect, useMemo } from "react";
import QRCode from "qrcode";
import DateConverter from "@heartinz/date_and_time_processor";
import { FormatedSaleData } from "../../GlobelSaleData";
import { useContextApi } from "../../../../context/ContextApi";
import { useAuth } from "../../../../context/AuthProvider";
import { useNetwork } from "../../../../context/NetworkContext";
import { useShowAlert } from "../../../../context/AlertContext";
import { usePermission } from "../../../../context/PermissionContext";
import handleError from "../../../../constants/handleError";
import Messages from "../../../../constants/Messages";
import AxiosInstance from "../../../AxiosInstance";
import jsPDF from "jspdf";
import InterRegular from "../../../../components/pages/estimation/font/Inter_24pt-Regular-normal";
import InterBold from "../../../../components/pages/estimation/font/Inter_24pt-Bold-normal";
import NotoSansMonoBold from "../../../../components/pages/sale/font/NotoSansMono-Bold-bold";
import NotoSansMonoReular from "../../../../components/pages/sale/font/NotoSansMono-Regular-normal";
import { formatCurrency } from "@heartinz/finance";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
export const useInvoiceData = ({
  isData,
  onClose,
  onDataUpdate,
  onDataChange,
  optData,
  setOptData,
}) => {
  const [data, setData] = useState({});
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [terms, setTerms] = useState([]);
  const [download, setDownload] = useState(false);
  const [billing, setBilling] = useState(false);
  const [selectTermalOption, setSelectTermalOption] = useState("");
  const [selectHALFA4Option, setSelectHALFA4Option] = useState("");
  const [closeAuto, setCloseAuto] = useState(true);
  const [saleLoading, setSaleLoading] = useState(false);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isPaySettleModalOpen, setIsPaySettleModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedSale, setSelectedSale] = useState(null);

  const globalData = FormatedSaleData(data);
  const { isUser, updateSettings, settings } = useAuth();
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { storeSettings } = usePermission();
  const { useEscapeKey } = useContextApi();
  
  const latestVersion = useMemo(() => {
    return isData?.saleVersion;
  }, [isData]);

  const [selectedSize, setSelectedSize] = useState(
    storeSettings?.printerSettings?.paperSize,
  );  
  const selectedTheme = storeSettings?.invoiceSettings?.template;
  const saleMode = globalData?.preSaleData?.preSaleMode?.toUpperCase();
  const isProforma = saleMode === "PROFORMA_INVOICE";
  const isBill_isTax =
    storeSettings?.saleSettings?.saleModeSettings?.isBill_isTax;
  const isBillReceipt =
    globalData?.salemode?.toUpperCase() === "BILL" && isBill_isTax;
  const isBill = globalData?.salemode?.toUpperCase() === "BILL";
  const preSaleMode = globalData?.preSaleData?.preSaleMode?.toUpperCase();
  const isPreSale = ["PROFORMA_INVOICE", "ESTIMATION", "QUOTATION"].includes(preSaleMode);
  
  const numberLabel =
    preSaleMode === "PROFORMA_INVOICE"
    ? "Proforma No:"
    : preSaleMode === "ESTIMATION"
      ? "Estimation No:"
    : preSaleMode === "QUOTATION"
      ? "Quotation No:"
    : isBill
      ? "Bill No:"
      : "Invoice No:";

  const documentTitle =
    globalData?.salemode === "BILL"
      ? "BILL RECEIPT"
      :preSaleMode === "PROFORMA_INVOICE"
        ? "PROFORMA INVOICE"
      : preSaleMode === "ESTIMATION"
        ? "ESTIMATION"
      : preSaleMode === "QUOTATION"
      ? "QUOTATION"  
      : globalData.salemode ||preSaleMode;

  const documentConfig = isData?.preSaleData?.preSaleMode
    ? {
        title: documentTitle,
        numberLabel,
        fromLabel: "",
        fromData: globalData?.preSaleData?.billingStoreProfile,
        image: globalData?.preSaleData?.billingStoreProfile?.image,
        toLabel: "Customer Details:",
        toData: globalData?.preSaleData?.preSaleTo,
        number: globalData?.preSaleData?.preSaleNo,
        items: globalData?.preSaleData?.preSaleItems,
        amountInWords: globalData?.preSaleData?.amountInWords,
        grandTotal: globalData?.preSaleData?.grandTotal,
        totalTaxAmount: globalData?.preSaleData?.totalTaxAmount,
        totalBasePrice: globalData?.preSaleData?.totalBasePrice,
        sgstAmount: globalData?.preSaleData?.sgstAmount,
        cgstAmount: globalData?.preSaleData?.cgstAmount,
        igstAmount: globalData?.preSaleData?.igstAmount,
        totalSoldPrice: globalData?.preSaleData?.totalSoldPrice,
        totalDiscount: globalData?.preSaleData?.totalDiscount,
        remarks:globalData?.preSaleData?.remarks
      }
    : {
        title: documentTitle,
        numberLabel,
        fromLabel: "",
        image: globalData?.salefrom?.image,
        fromData: globalData?.salefrom,
        toLabel: "Customer Details",
        toData: globalData?.saleto,
        number: globalData?.saleno,
        items: globalData?.saleitems,
        amountInWords: globalData?.amountinwords,
        grandTotal: globalData?.grandtotal,
        totalTaxAmount: globalData?.totaltaxamount,
        totalBasePrice: globalData?.totalbaseprice,
        sgstAmount: globalData?.sgstamount,
        cgstAmount: globalData?.cgstamount,
        igstAmount: globalData?.igstamount,
        totalSoldPrice: globalData?.totalsoldprice,
        totalDiscount: globalData?.totaldiscount,
        remarks:globalData?.remark
      };
  const ReturnSaleTitle = "CREDIT NOTE";
  
  const saleDate = data?.saledate || data?.preSaleData?.preSaleUTCDate;
  const timezone =
    data?.saleby?.timezone || settings?.mainStoreDetails?.timezone;
  const balanceDue = globalData?.grandtotal - globalData?.paidamount;
  const actualPaidAmount = globalData?.grandtotal - globalData?.balanceDue;
  const isInterState =
    globalData?.salefrom?.statecode &&
    globalData?.saleto?.statecode &&
    globalData?.salefrom?.statecode !== globalData?.saleto?.statecode;
  const hasShipping =
    globalData?.saleto?.shippingAddress &&
    optData?.isCustomerDisplay &&
    (globalData?.saleto?.shippingAddress?.addressline1 ||
      globalData?.saleto?.shippingAddress?.addressline2);

  let saleTime = "--:--";
  let createdTime = {
    date: "--",
    time: "--",
  };

  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }
  const createDate = !isProforma ? data?.createdAt : data?.createdAt;
  if (createDate) {
    const zoned = DateConverter.convertToTimeZone(createDate, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  useEscapeKey(onClose);

  const handleResetSale = () => {
    setSaleLoading(true);
    setTimeout(() => {
      setData({
        ...selectedSale?.saleData,
        projectId:
          typeof selectedSale?.saleData?.projectId === "string"
            ? isData?.projectId
            : selectedSale?.saleData?.projectId,
      });
      // setData(selectedSale?.saleData);
      setSaleLoading(false);
    }, 300);
    setCloseAuto(false);
  };

  const handleModeConfirm = () => {
    setShowConfirm(true);
  };
  const handleSelectedSale = (sale) => {
    if (sale?.saleVersion) {
      if (sale?.saleVersion === data?.saleVersion) return;
    }
    setSaleLoading(true);
    setTimeout(() => {
      setData(sale?.saleData);
      setSaleLoading(false);
    }, 300);
  };

  const handlelatestSale = (sale) => {
    setSelectedSale(sale);
  };

  const handleGenerateInvoice = async (data) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const payload = {
        saleid: data._id,
        toSaleMode: "INVOICE",
      };
      var response = await AxiosInstance.patch(
        "module/sale/convert-salemode",
        payload,
      );
      setData(response.data.results);
      if (onDataChange) {
        onDataUpdate();
      }
      showAlert("success", Messages.SUCCESS.SALE_ADDED);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
      setShowConfirm(false);
    }
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEsc);
    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  useEffect(() => {
    const upi = storeSettings?.paymentSettings?.upiId;

    const name = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
    if (!upi) return; // skip until upi is available

    const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
    // console.log("ip", upiUrl);
    QRCode.toDataURL(upiUrl)
      .then((url) => {
        setQrCodeDataUrl(url);
      })
      .catch((err) => {
        console.error("QR Code generation failed: ", err);
      });
  }, [
    storeSettings?.paymentSettings?.upiId,
    storeSettings?.paymentSettings?.bankDetails?.beneficiaryName,
  ]);

  useEffect(() => {
    setData(isData);
  }, [isData]);

  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings]);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal",
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS(
          "NotoSansMono_24pt-Regular-normal.ttf",
          NotoSansMonoReular,
        );
        this.addFileToVFS(
          "NotoSansMono_24pt-Bold-normal.ttf",
          NotoSansMonoBold,
        );
        this.addFont(
          "NotoSansMono_24pt-Regular-normal.ttf",
          "NotoSansMono-Regular",
          "normal",
        );
        this.addFont(
          "NotoSansMono_24pt-Bold-normal.ttf",
          "NotoSansMono-Bold",
          "bold",
        );
      },
    ]);
  }, []);

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECEIPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };
  return {
    data,
    setData,
    globalData,
    selectedTheme,
    selectedSize,
    setSelectedSize,
    createdTime,
    terms,
    qrCodeDataUrl,
    latestVersion,
    balanceDue,
    actualPaidAmount,
    isInterState,
    download,
    setDownload,
    billing,
    setBilling,
    selectTermalOption,
    setSelectTermalOption,
    selectHALFA4Option,
    setSelectHALFA4Option,

    isBtnLoading,
    setBtnLoading,
    isPaySettleModalOpen,
    setIsPaySettleModalOpen,
    isMainModalOpen,
    setIsMainModalOpen,

    saleLoading,
    setSaleLoading,

    closeAuto,
    setCloseAuto,

    showConfirm,
    setShowConfirm,

    selectedSale,
    setSelectedSale,

    optData,
    setOptData,

    handleResetSale,
    handleSelectedSale,
    handlelatestSale,
    handleModeConfirm,
    // isReturnView,
    // setIsReturnView,
    isUser,
    updateSettings,
    checkNetwork,
    showAlert,
    saleDate,
    timezone,
    saleTime,
    storeSettings,
    isBillReceipt,
    documentTitle,
    hasShipping,
    handleGenerateInvoice,
    formatTrackMode,
    ReturnSaleTitle,

    isProforma,
    documentConfig,
    isBill_isTax,
    isPreSale
  };
};
